<template>
  <header class="has-background-warning">
    <template v-if="status?.underMaintenance">
      <p class="m-2">{{$t('under_maintenance')}}</p>
    </template>
  </header>
  <main class="boxed-container">
    <div class="logos">
      <img class="logo-primary" :src="'../de.elo.ix.plugin.rest/auth2/branding/logo-primary'" alt="logo-primary" />
      <img class="logo-secondary" :src="'../de.elo.ix.plugin.rest/auth2/branding/logo-secondary'"  alt="logo-secondary" />
    </div>
    <suspense>
      <template #fallback>
        <b-loading />
      </template>
      <slot></slot>
    </suspense>
  </main>
  <footer>
    <p class="m-2">{{status?.license ?? 'ELO Digital Office'}}</p>
  </footer>
</template>

<style>
@import '../css/theme.css';

body {
  background: #E7E8E9 none;
  background-size: cover;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}


.boxed-container {
  background-color: white;
  width: 480px;
  border-radius: 4px;
  text-align: center;
  padding: 40px;
  box-shadow: 0 4px 16px #00000052; /* EAUTH2-210 */
}

@media only screen and (max-width: 480px) {
  .boxed-container {
    border-radius: 0;
    width: 100%;
  }
}

.logos {
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 40px;
}


.logo-primary {
  align-self: flex-start;
  max-width: 60%;
  height: 48px;
}

.logo-secondary {
  align-self: flex-end;
  max-width: 30%;
  height: 12px;
}

section {
  margin: 1rem 0;
}

section:first-child {
  margin-top: 0;
}

section:last-child,
section:has(+ footer) {
  margin-bottom: 0;
}

#app > header,
#app > footer {
  width: 100%;
  background-color: #FFFFFF;
  text-align: center;
}
</style>

<script setup lang="ts">
import '@elo/ui-buefy-v3/dist/elo-ui.css';
import '@elo/font-elo-sans-pro';
import '../css/e-icons.css';
import {API_URL, fetchJson} from "../ts/utils"; // EAUTH2-33
import {ref, Suspense} from 'vue'
import {$t} from "../ts/translations";

document.body.style.backgroundImage = `url('${API_URL}/branding/background')`;

const license = ref('ELO Digital Office');


const status = ref(null)
fetchJson(API_URL + '/status').then(s => status.value = s)
</script>
